import Vue from 'vue';
import moment from 'moment';
import mixin from './../../../mixins/mixin';
import { mapGetters } from 'vuex';
import accountService from './../../../services/account';
import store from "../../../store";

export default {
  data() {
    return {
      user: {
        id: store.state.account.id,
        full_name: store.state.account.full_name,
        email: store.state.account.email,
        parent_id: store.state.account.parent_id,
        avatar: store.state.account.avatar,
        first_name : store.state.account.first_name,
        last_name : store.state.account.last_name,
        lang: localStorage.getItem('lang'),
        country_id: 1,
        role: store.state.account.role,
        confirmed: store.state.account.confirmed,
        is_team_member: localStorage.getItem('is_team_member'),
        rights: store.state.account.rights,
        currency: store.state.account.currency
      },
      selectedRental: null,
      rentals: [],
      marketDate: [ moment().format('MMM DD, YYYY'), moment().add(30, 'days').format('MMM DD, YYYY') ]
    };
  },
  components: {
    VLayout: require('layouts/default/default.vue'),
    VPanel: require('components/panel/panel.vue'),
    VLoading : require('components/loading/loading.vue'),
    VExportAnalysis: require('components/export-analysis/export-analysis.vue')
  },
  mixins:[mixin],
  async mounted() {
    await accountService.fetchUserAccount(this);
    await accountService.getAccountRights(this);
    await this.changeTab();
  },
  methods: {
    changeTab() {
      if(this.$route.params.id) {
        this.selectedRental = this.$route.params.id;
      } else {
        if(this.rentals.length > 0) {
          this.selectedRental = this.rentals[0].id;
        }
      }
      let params = {
        id: this.selectedRental
      };
      if (this.user.is_team_member) {
        let userRights = this.user.rights.filter((right) => {
          return right.analytics === 1;
        });
        if (userRights.length > 0) {
          userRights.forEach((right) => {
            if (right.analytics) {
              if (right.analytics_general) {
                Vue.router.push({
                  name: 'analytics.general.tab',
                });
              }
              // else if (right.analytics_rentals) {
              //   Vue.router.push({
              //     name: 'analytics.rentals.tab'
              //   });
              // }
              else if (right.analytics_reviews) {
                Vue.router.push({
                  name: 'analytics.reviews.tab'
                });
              } else if (right.analytics_environment) {
                Vue.router.push({
                  name: 'analytics.environment.tab',
                  params: params
                });
              } else if (right.analytics_market) {
                params.start = moment(this.marketDate[0], 'MMM DD, YYYY').format('Y-MM-DD');
                params.end = moment(this.marketDate[1], 'MMM DD, YYYY').format('Y-MM-DD');
                Vue.router.push({
                  name: 'analytics.market.tab',
                  params: params
                });
              }
            }
          });
        } else {
          toastr.error(this.$t("analytics.index.page_not_allowed"));
        }
      } else {
        Vue.router.push({
          name: 'analytics.general.tab',
        });
      }
    }
  },
  computed: {
    account: function () {
      return this.$store.state.account;
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/analytics/index/index.js